<template>
  <div class="wrapper">
    <Loader v-if="loader"></Loader>
          <v-form v-model="isValid" ref="form">
            <v-text-field
              v-for="(item,key) in form"
              :key="key"
              solo
              v-model="item.value"
              :rules="item.rules"
              :type="item.type"
              :label="item.label"
              required
            />
          </v-form>
          <v-btn block depressed class="success" @click="submit()">Submit</v-btn>
  </div>
</template>

<script>
import Loader from "../components/Loader";
export default {
  components: { Loader },
  data() {
    return {
      isValid: false,
      loader: false,
      form: {
        Account_No: {
          label: "Account Number",
          type: "number",
          rule: [v => !!v || "This field is required"],
          value: ""
        },
        IFSC: {
          label: "IFSC",
          type: "text",
          rule: [v => !!v || "This field is required"],
          value: ""
        },
        Bank_Name: {
          label: "Bank Name",
          type: "text",
          rule: [v => !!v || "This field is required"],
          value: ""
        },
        Amount: {
          label: "Amount",
          type: "number",
          rule: [v => !!v || "This field is required"],
          value: ""
        },
        Bene_Name: {
          label: "Benificiary Name",
          type: "text",
          rule: [v => !!v || "This field is required"],
          value: ""
        },
        Sender_MobileNo: {
          label: "Sender Mobile No",
          type: "number",
          rule: [v => !!v || "This field is required"],
          value: ""
        },
        Sender_Name: {
          label: "Sender Name",
          type: "text",
          rule: [v => !!v || "This field is required"],
          value: ""
        }
      }
    };
  },
  computed: {
    user() {
      return this.$store.getters.user;
    },
    security() {
      return this.$store.getters.security;
    }
  },
  methods: {
    notification(type, message) {
      this.$notify({
        group: "foo",
        title: "Important message",
        text: message,
        duration: 5000,
        type: type
      });
    },
    submit() {
      const vm = this;
      let form = {
        MobileNo: vm.user.phone,
        Password: vm.user.password,
        AuthKey: vm.user.authkey,
        Source: "json",
        Security_Key: vm.security
      };
      for (let key in vm.form) {
        if (vm.form[key].value === "")
          return vm.notification("error", vm.form[key].label + " is required");
        form[key] = vm.form[key].value;
      }
      vm.loader = true;
      vm.$store
        .dispatch("axiosdmrpost", {
          url: "Direct_Payout",
          type: "instapay",
          data: form
        })
        .then(function(res) {
          vm.loader = false;
          if (res.data.statuscode === "True") {
            vm.notification("success", res.data.status);
            for (let key in vm.form) {
                vm.form[key].value = ""
            }
            return;
          }
          return vm.notification("error", res.data.status);
        })
        .catch(function(error) {
          vm.loader = false;
          vm.notification("error", error.message);
        });
    }
  }
};
</script>

<style scoped>
  .wrapper {
    width: 400px;
    margin:0 auto;
    margin-top: 30px;
  }
</style>